import { BadgeAnchor, Card, Divider, Tooltip } from '@tecsinapse/cortex-react'
import clsx from 'clsx'
import React from 'react'
import { FaRegFileAlt } from 'react-icons/fa'
import { GoPerson } from 'react-icons/go'
import { LiaFolderOpenSolid } from 'react-icons/lia'
import { MdOutlineCalendarMonth } from 'react-icons/md'
import { useNavigate } from 'react-router-dom'
import { i18n } from '@/i18n'
import { ItemBiblioteca } from '@/core/types/graphql'
import { BiLock, BiWorld } from 'react-icons/bi'
import { t } from '@lingui/core/macro'
import { NewItemBadge } from './new-item-badge'
import { isNewItem } from '../utils/functions'

interface ItemBibliotecaViewCardCortexProps {
  item: ItemBiblioteca
  isSelected?: boolean
  onSelectItem?: (item: ItemBiblioteca) => void
  onClickItem?: (item: ItemBiblioteca) => void
  onSelectViewItem?: (item: ItemBiblioteca) => void
}

interface ItemBibliotecaCardCortexProps
  extends ItemBibliotecaViewCardCortexProps {
  isRecentFiles?: boolean
}

export const ItemArquivoBibliotecaCard = ({
  item,
  isSelected,
  onSelectItem,
  onClickItem,
  onSelectViewItem,
  isRecentFiles
}: ItemBibliotecaCardCortexProps) => {
  const {
    nome,
    dataCriacao,
    isPasta,
    proprietario,
    arquivoMiniaturaLink,
    isPublico
  } = item
  const isPastaPublico = isPasta && isPublico
  const isPastaPrivado = isPasta && !isPublico
  const navigate = useNavigate()

  return (
    <Card
      className={clsx(
        'flex-1 flex-row flex items-center space-x-deca justify-between hover:bg-primary-light hover:cursor-pointer',
        isSelected && 'bg-primary-light'
      )}
      onClick={e => {
        e.stopPropagation()
        if (isRecentFiles) {
          navigate(`/biblioteca/${item.pastaPai?.id}`)
        } else onClickItem?.(item)
      }}
      onDoubleClick={e => {
        e.stopPropagation()
        if (item.arquivoImagem) onSelectViewItem?.(item)
        else onSelectItem?.(item)
      }}
    >
      <div className='rounded-mili border items-center flex text-primary-medium overflow-clip'>
        {isPasta ? (
          <LiaFolderOpenSolid size={24} className='m-deca' />
        ) : arquivoMiniaturaLink ? (
          <img
            src={arquivoMiniaturaLink}
            className='w-[58px] h-[58px] object-cover'
          />
        ) : (
          <FaRegFileAlt size={24} className='m-deca' />
        )}
      </div>

      <div className='flex flex-col space-y-mili flex-1 min-w-0'>
        <div className='flex flex-1 items-center gap-mili'>
          <p
            className='truncate font-bold text-h5 text-secondary-xdark'
            title={nome}
          >
            {nome}
          </p>
          {isPastaPublico ? (
            <Tooltip text={t`Pasta Pública`}>
              <BiWorld className='text-primary-medium' />
            </Tooltip>
          ) : isPastaPrivado ? (
            <Tooltip text={t`Pasta Privada`}>
              <BiLock className='text-primary-medium' />
            </Tooltip>
          ) : null}
        </div>
        <Divider />
        <div className='flex flex-row justify-between w-full text-sub text-secondary-xdark self-start space-x-deca'>
          <div className='flex flex-row items-center space-x-deca'>
            <div className='flex flex-row items-center space-x-micro'>
              <MdOutlineCalendarMonth
                className='text-primary-medium'
                size={16}
              />
              <p className='text-sub text-secondary-xdark'>
                {i18n.date(dataCriacao, { dateStyle: 'short' })}
              </p>
            </div>
            <div className='flex flex-row items-center space-x-micro'>
              <GoPerson className='text-primary-medium' size={16} />
              <p className='text-sub text-secondary-xdark'>
                {proprietario?.nome}
              </p>
            </div>
          </div>
          <NewItemBadge dataCriacao={dataCriacao} />
        </div>
      </div>
    </Card>
  )
}
